import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ chapter, title, sub, dark = false, center = true }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-16 sm:mb-20`}>
    <Reveal>
      <span
        className={`inline-block font-display text-sm font-semibold tracking-[0.3em] uppercase px-3 py-1 border-2 ${
          dark ? "border-hero-gold text-hero-gold" : "border-hero-black text-hero-black"
        }`}
        data-testid={`section-tag-${chapter}`}
      >
        {chapter}
      </span>
    </Reveal>
    <Reveal delay={0.1}>
      <h2
        className={`font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight mt-6 leading-[1.02] ${
          dark ? "text-white" : "text-hero-black"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.2}>
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-white/70" : "text-hero-black/70"}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
